import { AbstractControl } from '@angular/forms';

export function BudgetMaxStodnivaLower(control: AbstractControl) {
  if (control.value) {
    const parsedValue = JSON.parse(control.value);
    const noMaxStodnivaLower = !parsedValue.projektparter.some(
      (p) =>
        p.bidragPerAr.some((bidrag) => bidrag.summa > 0) &&
        p.maxStodniva?.varde < p.maxStodniva?.beraknadStodniva,
    );
    if (noMaxStodnivaLower) {
      return;
    }
  }

  return { MaxStodnivaLower: true };
}
